import { createResourceActions } from 'utils/actionsGenerator';

import {
    FETCH_BALANCE,
    FETCH_BALANCE_FAIL,
    FETCH_BALANCE_SUCCESS,
    types,
} from './reducer';

export const { fetch, patch } = createResourceActions({
    name: 'company',
    types,
    url: '/companies',
});

export const fetchBalance = (id) => ({
    id,
    payload: {
        request: {
            method: 'get',
            params: { withBalance: 1 },
            url: `/companies/${id}`,
        },
    },
    types: [FETCH_BALANCE, FETCH_BALANCE_SUCCESS, FETCH_BALANCE_FAIL],
});
